import { Button } from '../ui'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui'

interface RejectConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isSubmitting?: boolean
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
}

export function RejectConfirmationDialog({
  open,
  onOpenChange,
  onConfirm,
  isSubmitting = false,
  title = 'Reject Transaction',
  description = 'Are you sure you want to reject this transaction? This action cannot be undone.',
  confirmText = 'Reject',
  cancelText = 'Cancel',
}: RejectConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            className="h-10"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            variant="destructive"
            className="h-10"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Rejecting...' : confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
